// "use strict";

angular.module('app.models.DatapointConfig', [])
    .factory('__DatapointConfig', function (restmod, f_User, appConfig) {
        'ngInject';

        var WellKnown =
        {
            "BatteryState": "49fa9f10-c988-4782-b970-0a3daf13df5f",
            "SignalStrength": "a49387b7-e1b9-4270-be14-752868641a00",
            "RBGTemperaturSollWert": "96e92aa1-814c-4fc0-82e7-ad2a7f69ac6a",
            "RBGTemperaturIstWert": "777c1a8e-ec1c-4a15-9bcc-4ec5b8e0e4f4",
            "EnergyPlugActive": "",
            "WindowOpen": "9c9aef3d-3862-4e68-b687-c88b9b97595"
        };
        // Generate a searchstring to fast detect if Config is a WellKnownConfig
        var WellKnownSearchString = Object.keys(WellKnown).map(function (key) {
            return WellKnown[key];
        });
        var ConfigFunctions = {
            $pk: 'DatapointConfigId',
            // '_type':{map: '$type'},
            prepareConfig: function () {
                if (!this.$UI) {
                    this.$UI = {};
                }
                this.decodeUIHint();
                this.resolvePermissions();

                if (this.canWrite) {


                } else {
                    if (this.canView) {

                    }
                }

                this.defineUIElement();
                //this.Description = 'Million Dollar Config'+this.DisplayName;
                if (this.DatapointType === 2 && this.PossibleValues && this.PossibleValues['True'] && this.PossibleValues['False']) {

                    this.PossibleValues =
                    {

                        false: this.PossibleValues['False'],
                        true: this.PossibleValues['True']
                    }
                }
                // Battery Status
                if (angular.isUndefined(this.$UI)) {
                    this.$UI = {};
                }
                if (WellKnownSearchString.indexOf(this.DatapointConfigId) > -1) {
                    if (this.DatapointConfigId == WellKnown.BatteryState) {
                        this.$UI.BatteryState = true;
                        this.$UI.HideInList = true;
                    }
                    else if (this.DatapointConfigId == WellKnown.SignalStrength) {
                        this.$UI.HideInList = true;
                        this.$UI.SignalStrength = true;
                    }
                    else if (this.DatapointConfigId == WellKnown.RBGTemperaturSollWert) {
                        this.$UI.RBGTemperaturSollWert = true;
                        this.$UI.KnownImageName = 'temp-soll';
                        this.$UI.HideInList = false;
                    }
                    else if (this.DatapointConfigId == WellKnown.RBGTemperaturIstWert) {
                        this.$UI.RBGTemperaturIstWert = true;
                        this.$UI.KnownImageName = 'temp-ist';
                        this.$UI.HideInList = false;
                    }
                    else if (this.DatapointConfigId == WellKnown.EnergyPlugActive) {
                        this.$UI.RBGTemperaturIstWert = true;
                        this.$UI.KnownImageName = 'geraete';
                        this.$UI.HideInList = false;
                    }
                    else if (this.DatapointConfigId == WellKnown.WindowOpen) {
                        this.$UI.windowOpen = true;
                        //this.$UI.KnownImageName = 'fenster-auf';
                        this.$UI.HideInList = false;
                    }
                } else {
                    this.$UI.HideInList = false;
                }

                var name;
                if (this.ImageName && this.ImageName.indexOf('_') !== -1) {
                    // If we got an Imagename like hk1_70x52
                    name = this.ImageName.split('_')[0];
                } else {
                    name = this.ImageName;
                }

                this.$UI.KnownImageName = name;


            },
            resolvePermissions: function () {
                var b,
                    a;
                var UserLevel = f_User.getUserLevel();

                if (this.UserLevelRead >= UserLevel) {
                    // normaly API will filter non readable
                    a = true;
                } else {
                    a = false;
                }
                this.canView = a;
                /*
                 Actual Value = 0,
                 AlarmFlagWarning = 4,
                 AlarmFlagError = 5,
                 AlarmGlobalFlagError = 6,
                 */
                var readCategorys = [0, 4, 5, 6];
                if (
                    readCategorys.indexOf(this.Category) >= 0 ||
                    (
                        this.UserLevelWrite > UserLevel // We can't write it

                    )
                ) {
                    b = false;
                } else {
                    b = true;
                }
                this.canWrite = b;

            },
            defineUIElement: function (a) {
                var apiUIElement = undefined;
                var uielement = '';


                if (this.UIHint != null) {
                    this.defineUIElementByAPI();
                } else {
                    this.defineUIElementByParams();
                }
                //this.$UI.Type = this.UIElement;
            },
            decodeUIHint: function () {
                var o = this;
                if (!o.$UI) {
                    o.$UI = {};
                }
                ;
                if (o.UIHint) {
                    o.$UI = angular.extend(o.$UI, o.deserializeUIObject(o.UIHint));
                }

            },
            defineUIElementByAPI: function () {


                if (this.$UI.Type == "Date") {
                    this.UIElement = "Date";
                }

                if (this.$UI.Type == "DropDown") {
                    this.UIElement = "DropDown";
                }

                if (this.$UI.Type == "OnOffSlider") {
                    this.UIElement = "OnOffSlider";
                }
                if (this.$UI.Type == "Slider") {
                    this.UIElement = "Slider";
                }


                if (this.$UI.Type == "Password") {
                    this.UIElement = "Password";
                }
                if (this.$UI.Type == "SmartSlider") {
                    this.UIElement = "SmartSlider";
                    var withOffState = this.$UI.WithOffState == 'true' ? '1' : '0';
                    var withProgress = this.$UI.WithProgress == 'true' ? '0' : '1';
                    this.ComputedClass = "slider-"+ withOffState + '-'+ withProgress ;
                }
                if (this.$UI.Type == "PlayButton") {
                    //alert(ui.length);
                    this.UIElement = "PlayButton";
                }
                // Fallback for Scenes. If no UIElement is defined, set to Input!
                if(!this.UIElement){
                    this.UIElement = 'Input';
                }


            },
            defineUIElementByParams: function () {
                var uielement = '';

                if (this.PossibleValues && Object.keys(this.PossibleValues).length) {
                    // We got possible Values and Dropdown
                    /* Kovandja 2017-05-29: changed name from 'DropDown' to 'Dropdown'
                       to unify naming across the application */
                    uielement = 'Dropdown';
                } else {

                    // Depending on Datapoint Type
                    // Set UIElement
                    switch (this.DatapointType) {


                        case 2:
                            uielement = 'OnOffSlider';
                            break;


                        //case 0:  => Input
                        //case 1:  => Input
                        //case 3:  => Input
                        //case 4:  => Input
                        case 4 :
                            uielement = 'Date';
                            break;
                        case 5 :
                            uielement = 'Curve2d';
                            break;
                        default:
                            uielement = 'Input';

                    }

                }
                ;
                this.UIElement = uielement;
                this.$UI.Type = uielement;

            }
        };

        /* Restmod Model */

        var model = restmod.model('/Datapoint/GetConfigs').mix('BaseModel').mix(ConfigFunctions).mix({
            //  '_type': {map: '$type'},
            $config: {name: 'ResponseData', plural: 'ResponseData'},
            $hooks: {
                'before-request': function (_req) {
                    _req.method = 'POST';
                    _req.data = _req.params;
                    _req.params = '';
                },
                'after-feed': function (data) {
                    this.$UI = {};

                    this.prepareConfig();

                }
            },
            $extend: {
                hasBattery: function () {
                    return this.DatapointConfigId == WellKnown.BatteryState;
                },
                hasSignal: function () {
                    return this.DatapointConfigId == WellKnown.SignalStrength;
                },
                Scope: {

                    $collection: function (params) {
                        var url;

                        if (params && !params.url) {
                            url = 'GetConfigs';
                            params = {'DeviceType': params.DeviceType, 'DatapointConfigIds': params.DatapointConfigIds};
                        } else if (!params) {
                            params = {};
                            url = 'GetConfigs';
                        } else {
                            url = params.url;
                        }
                        delete params.url;
                        url = '/Datapoint/' + url;
                        var original = this;
                        var o = {
                            $urlFor: function () {
                                return original.$urlFor(url);
                            }
                        };
                        return this.$super(params, o);
                    },

                    $search: function (a) {
                        return $collection(a).$refresh();
                    },
                    $find: function () {
                    },
                    $ByDeviceId: function (params) {
                        return this.$collection(params).$decorate(
                            {
                                'before-request': function (_req) {
                                    _req.method = 'POST';
                                    //_req.params = null;
                                    _req.params = params;
                                    _req.url = appConfig().api_host + 'Datapoint/GetConfigsByDeviceId';
                                },
                                'after-request': function () {
                                }
                            }, function () {
                                return this.$fetch();
                            });
                    },
                    $ByFilterAndDeviceId: function (params) {
                        return this.$collection(params).$decorate(
                            {
                                'before-request': function (_req) {
                                    _req.method = 'POST';
                                    _req.params = params;
                                    _req.url = appConfig().api_host + 'Datapoint/GetConfigsByFilterAndDeviceId';
                                },
                                'after-request': function () {
                                }
                            }, function () {
                                return this.$fetch();
                            });
                    },
                    $ByFilter: function (params) {
                        return this.$collection(params).$decorate(
                            {
                                'before-request': function (_req) {
                                    _req.method = 'POST';
                                    _req.params = params;
                                    _req.url = appConfig().api_host + 'Datapoint/GetConfigsByFilter';
                                },
                                'after-request': function () {
                                }
                            }, function () {
                                return this.$fetch();
                            });
                    },
                    $GetByIds: function (list, dt) {
                        return this.$collection({'DatapointConfigIds': list, 'DeviceType': dt}).$refresh();
                    },
                    $GetByDeviceType: function (list) {
                        return this.$collection({
                            'DatapointValues': list,
                            url: 'GetConfigsByDatapointValues'
                        }).$refresh();
                    },
                },

            }
        })

        return model;
    });
